import VerifiedComponent from './VerifiedComponent';

import firebaseApp from '../../firebase/firebaseInit';
import CustomModel from '../../lib/popupModel/CustomModel/CustomModel';
import {
  contractDetailsErrorAction,
  contractDetailsLoaderAction,
  contractNumberErrorAction,
  contractNumberLoaderAction,
  getAllContractsAction,
  getContractDetailsAction,
  getContractNumbersAction,
  getPaymentScheduleAction,
  getUserDetailsInfoAction,
  noScheduleDataAction,
  paymentScheduleErrorAction,
  paymentScheduleLoaderAction,
  popViewAction,
  pushViewAction,
  resetStateAction,
  setOrganization,
  setRole,
  setRoleAccess,
  loadUserDevicePushToken,
  showEnablePushNotificationModel,
} from '../../redux/actions/Actions';
import {appStore} from '../../redux/createStore';
import {getAPICall, postAPICall} from '../../services/apiCallsHandler';
import {DataHolder} from '../../utils/DataHolder';
import {
  Navigate,
  generateTraceID,
  getAllRelationships,
  postMessageTriggerPushSettingOnMobile,
} from '../../utils/util';
import PostVerificationComponent from '../postVerificationComponent/postVerificationComponent';
import SecurityVerification from '../SecurityVerification/SecurityVerification';
import TermsAndConditions from '../termsAndConditions/termsAndConditions';
import TractorLoader from '../TractorLoader/TractorLoader';

import {getMessaging, getToken} from 'firebase/messaging';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import './LandingPage.css';

const LandingPage = (props) => {
  const {i18n, t} = useTranslation();
  const [isPostVerified, setIsPostVerified] = React.useState(false);
  const [fetchContract, setFetchContract] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isPostVerificationOngoing, setIsPostVerificationOngoing] =
    React.useState(false);
  const [newOrg, setNewOrg] = React.useState(null);
  const [country, setCountry] = React.useState();
  const [tncAccepted, setTncAccepted] = React.useState(false);
  const [custId, setCustId] = React.useState(null);
  const [
    enablePushNotificationModelVisibility,
    setEnablePushNotificationModelVisibility,
  ] = React.useState(false);

  React.useEffect(() => {
    if (props.askForNotification) {
      setEnablePushNotificationModelVisibility(true);
    }
  }, [props.askForNotification]);

  const organization = '';
  const getUserDetailsFromOkta = async () => {
    await props.oktaAuth.getUser().then(async (fetchedUser) => {
      DataHolder.currentUserId = fetchedUser.userID;
      if (!fetchedUser.country) {
        fetchedUser.country = fetchedUser.countryCode;
      }
      setCountry(fetchedUser.country.toLowerCase());
      fetchedUser.country = fetchedUser.country.toLowerCase();
      generateTraceID(fetchedUser.userID);
      delete fetchedUser.headers;
      appStore.dispatch(getUserDetailsInfoAction(fetchedUser));
    });
  };

  const handlePostVerification = () => {
    setIsPostVerificationOngoing(false);
    setIsPostVerified(true);
    appStore.dispatch(pushViewAction('termsAndConditions'));
  };

  const backButtonHandler = (e) => {
    e.preventDefault();
    appStore.dispatch(popViewAction());
  };

  const getScheduleAndContractData = async () => {
    console.log(`contractCounts >>>>${props?.contractNumber?.contractCounts}`);

    if (
      props?.contractNumber?.contractCounts > 0 &&
      !props?.contractNumberError
    ) {
      const results = await Promise.allSettled([
        getPaymentScheduleData(),
        getContractDetails(),
      ]);

      if (
        results[0]?.value.pastDue?.pastDue == 0 &&
        Object.keys(results[0]?.value.paymentSchedules?.nextInstallment)
          .length == 0
      ) {
        appStore.dispatch(noScheduleDataAction(true));
        Navigate('contractDetails');
      }
    }
  };

  const getPaymentScheduleData = async () => {
    appStore.dispatch(paymentScheduleLoaderAction(true));
    let isOrg = !!props.selectedOrg;
    return getAPICall(
      `paymentSchedule?isOrg=${isOrg}&customerId=${props.selectedOrg}`,
      {
        isCallBack: false,
        errorTag: 'GET_PAYMENT_SCHEDULE_DATA',
        redirectToOops: false,
      },
      {
        stateName: 'paymentSchedule',
        actionName: getPaymentScheduleAction,
      }
    ).then((res) => {
      appStore.dispatch(paymentScheduleLoaderAction(false));
      if (res.isError) {
        appStore.dispatch(paymentScheduleErrorAction(res));
      }

      return res;
    });
  };

  const getContractDetails = async () => {
    appStore.dispatch(contractDetailsLoaderAction(true));
    let isOrg = !!props.selectedOrg;
    return getAPICall(
      `contractDetails?isOrg=${isOrg}&customerId=${props.selectedOrg}`,
      {
        isCallBack: false,
        errorTag: 'GET_CONTRACT_DETAILS',
        redirectToOops: false,
      },
      {
        stateName: 'contractDetails',
        actionName: getContractDetailsAction,
      }
    ).then((res) => {
      appStore.dispatch(contractDetailsLoaderAction(false));
      if (res.isError) {
        appStore.dispatch(contractDetailsErrorAction(res));
      }
    });
  };

  const checkCustomerStatus = async () => {
    const selectedCountry = localStorage.getItem('countryCode')
      ? localStorage.getItem('countryCode')
      : 'gb';
    i18n.changeLanguage(selectedCountry);
    setIsLoading(true);
    appStore.dispatch(contractNumberLoaderAction(true));

    const urlParams = new URLSearchParams(globalThis.location.search);
    let customerIdFromUrl = urlParams.get('custid');

    customerIdFromUrl = customerIdFromUrl
      ? atob(customerIdFromUrl.substring(5))
      : null;
    setCustId(customerIdFromUrl);
    await getUserDetailsFromOkta();
    await postAPICall(
      `customerStatus`,
      {},
      {
        errorTag: 'CUSTOMER_STATUS',
        redirectToOops: true,
      }
    ).then(async (customerStatus) => {
      const custIdFrmCustomerStatus = customerStatus?.body?.custId;
      const isPostVerifiedFlg = customerStatus?.body?.isPostVerified;
      const tncAcceptedFlg = customerStatus?.body?.tncAccepted;
      const roleAccess = customerStatus?.body?.roleAccess;
      const role = customerStatus?.body?.role;

      custIdFrmCustomerStatus && setCustId(custIdFrmCustomerStatus);
      if (isPostVerifiedFlg) {
        setTncAccepted(tncAcceptedFlg);
        if (tncAcceptedFlg) {
          setFetchContract(tncAcceptedFlg);
        }
      } else if (
        !isPostVerifiedFlg &&
        (custIdFrmCustomerStatus || customerIdFromUrl)
      ) {
        setIsPostVerificationOngoing(true);
      }

      if (roleAccess) {
        appStore.dispatch(setRoleAccess(roleAccess));
      }
      if (role) {
        appStore.dispatch(setRole(role));
      }

      setIsPostVerified(isPostVerifiedFlg);
      setIsLoading(false);
    });
  };

  const redirectHome = () => {
    setTncAccepted(true);
    setFetchContract(true);
  };

  React.useEffect(() => {
    if (fetchContract) {
      setIsLoading(true);
      appStore.dispatch(contractNumberLoaderAction(true));
      getAPICall(
        `contracts`,
        {
          isCallBack: false,
          errorTag: 'GET_CONTRACTS_NUMBER',
          redirectToOops: false,
        },
        {
          stateName: 'allContracts',
          actionName: getAllContractsAction,
        }
      ).then(async (contractsResp) => {
        i18n.changeLanguage(contractsResp?.countryCode);
        if (contractsResp.isError || contractsResp.isContractError) {
          setIsLoading(false);
          appStore.dispatch(contractNumberErrorAction({isError: true}));
        } else {
          localStorage.setItem(`countryCode`, contractsResp.countryCode);
          appStore.dispatch(getContractNumbersAction(contractsResp));
          appStore.dispatch(contractNumberLoaderAction(false));
          setIsLoading(false);
        }
      });
    }
  }, [fetchContract]);

  React.useEffect(() => {
    if (globalThis.ReactNativeWebView) {
      globalThis.ReactNativeWebView.postMessage(
        JSON.stringify({
          countryCode: props?.allContracts?.countryCode
            ? props?.allContracts?.countryCode.toUpperCase()
            : 'EU',
        })
      );
    }
  });
  const CustomModalNotificationEnableBody = (
    <h5 className="uxf-alert-title">{t('ENABLE_NOTIFICATION_SETTING')}</h5>
  );

  const openPushNotificationSetting = async () => {
    const fcmtoken = localStorage.getItem('fcmtoken');

    if (fcmtoken) {
      const fetchedUser = await props.oktaAuth.getUser();
      await putDeviceTokenAPI(fcmtoken, fetchedUser.preferred_username);
      localStorage.removeItem('fcmtoken');
      localStorage.setItem('lastAsked', new Date().getTime().toString());
    } else {
      console.warn('No FCM token found in localStorage');
    }

    appStore.dispatch(showEnablePushNotificationModel(false));
    setEnablePushNotificationModelVisibility(false);
    postMessageTriggerPushSettingOnMobile();
  };

  const userCancelEnableNotification = () => {
    localStorage.setItem('lastAsked', new Date().getTime().toString());
    appStore.dispatch(showEnablePushNotificationModel(false));
    setEnablePushNotificationModelVisibility(false);
  };

  const renderEnableNotificationConfirmationModal = () => (
    <CustomModel
      className="ExitConfirmation"
      title={t('ENABLE_PUSH_HEADER')}
      subTitle={CustomModalNotificationEnableBody}
      primaryButtonText={t('CONTINUE')}
      primaryClickHandler={openPushNotificationSetting}
      secondaryButtonText={t('CANCEL')}
      secondaryClickHandler={userCancelEnableNotification}
      closeHandler={() => setEnablePushNotificationModelVisibility(false)}
      isVisible={enablePushNotificationModelVisibility}
    />
  );

  React.useEffect(() => {
    if (!props.oktaAuth || window.ReactNativeWebView) {
      return;
    }

    const initializeWebPushNotifications = async () => {
      try {
        const lastAsked = localStorage.getItem('lastAsked');
        const TWENTY_NINE_DAYS_MS = 2505600000;

        if (lastAsked) {
          const timeDiff = new Date().getTime() - parseInt(lastAsked);
          if (timeDiff <= TWENTY_NINE_DAYS_MS) {
            console.log('Skipping web notification prompt - asked recently');
            return;
          }
        }

        const fetchedUser = await props.oktaAuth.getUser();

        await navigator.serviceWorker.ready;
        const permission = await Notification.requestPermission();

        localStorage.setItem('lastAsked', new Date().getTime().toString());

        if (permission === 'granted') {
          const messaging = getMessaging(firebaseApp);
          const deviceToken = await getToken(messaging, {
            vapidKey: import.meta.env.VITE_VAPID_KEY,
          });

          if (deviceToken) {
            await putDeviceTokenAPI(
              deviceToken,
              fetchedUser.preferred_username
            );
          }
        }
      } catch (error) {
        console.error('Error initializing web push notifications:', error);
      }
    };

    initializeWebPushNotifications();
  }, [props.oktaAuth]);

  React.useEffect(() => {
    if (!props.oktaAuth) {
      return;
    }

    const checkPushNotificationStatus = async () => {
      try {
        const fetchedUser = await props.oktaAuth.getUser();
        const isMobile = !!window.ReactNativeWebView;

        if (isMobile) {
          const hasPendingToken = !!localStorage.getItem('fcmtoken');

          appStore.dispatch(
            loadUserDevicePushToken(fetchedUser.preferred_username)
          );
        }
      } catch (error) {
        console.error('Error checking push notification status:', error);
      }
    };

    checkPushNotificationStatus();
  }, [props.oktaAuth]);

  const putDeviceTokenAPI = async (deviceToken, username) => {
    await postAPICall(
      'deviceToken?oktaUserId=' + username,
      {
        deviceToken: deviceToken,
      },
      {
        errorTag: 'SET_DEVICE_TOKEN',
        logInfoMsg: 'customer device token set successfully ',
      }
    );
  };

  React.useEffect(() => {
    history.pushState(null, null, location.href);
    globalThis.addEventListener('popstate', backButtonHandler);
    return () => globalThis.removeEventListener('popstate', backButtonHandler);
  }, []);

  const loadedOrgRef = React.useRef(null);

  React.useEffect(() => {
    if (!props.allContracts) {
      return;
    }
    const orgKey = props.selectedOrg ?? 'personal';
    if (loadedOrgRef.current === orgKey) {
      return;
    }
    appStore.dispatch(resetStateAction());
    appStore.dispatch(getContractNumbersAction(props.allContracts));
  }, [newOrg]);

  React.useEffect(() => {
    if (!props.contractNumber) {
      return;
    }
    loadedOrgRef.current = props.selectedOrg ?? 'personal';
    getScheduleAndContractData();
  }, [props.contractNumber]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [props.viewList]);

  React.useEffect(() => {
    checkCustomerStatus();
  }, []);

  return (
    <>
      {isLoading ? (
        <TractorLoader />
      ) : isPostVerified ? (
        tncAccepted === false ? (
          <TermsAndConditions
            custId={custId}
            isRedirectedToHome={() => redirectHome()}
          />
        ) : (
          <>
            <VerifiedComponent
              customerId={custId}
              setOrganization={setOrganization}
              setNewOrg={setNewOrg}
              oktaAuth={props.oktaAuth}
              data={{
                ...props,
                organization,
                setNewOrg,
                t,
              }}
            />
            {renderEnableNotificationConfirmationModal()}
          </>
        )
      ) : isPostVerificationOngoing ? (
        <PostVerificationComponent
          country={country}
          custId={custId}
          onPostVerificationSuccess={() => handlePostVerification()}
        />
      ) : (
        <SecurityVerification
          country={country}
          successAction={(custId) => {
            setIsPostVerified(true);
            setFetchContract(true);
            setCustId(custId);
          }}
        />
      )}
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    viewList: state.appStates.viewList,
    allContracts: state.appStates?.allContracts,
    paymentSchedule: state.appStates.paymentSchedule?.paymentSchedules,
    paymentScheduleLoader: state.appStates.paymentScheduleLoader,
    contractDetails: state.appStates.contractDetails?.accountDetails,
    contractDetailsLoader: state.appStates.contractDetailsLoader,
    selectedOrg: state.appStates.selectedOrg,
    contractNumberError: state.appStates.contractNumberError,
    contractNumber: state.appStates.contractNumbers,
    askForNotification: state.appStates.askForNotification,
  };
};
export default connect(mapStateToProps)(LandingPage);
